import { useKeyboardShortcuts } from '@fiverr-private/hooks';

interface UseLightboxKeyboardProps {
    nextSource: VoidFunction;
    prevSource: VoidFunction;
    onClose: VoidFunction;
}

const useLightboxKeyboard = ({ nextSource, prevSource, onClose }: UseLightboxKeyboardProps) => {
    useKeyboardShortcuts([
        {
            trigger: 'escape',
            handler: onClose,
        },
        {
            trigger: 'arrowleft',
            handler: prevSource,
        },
        {
            trigger: 'arrowright',
            handler: nextSource,
        },
    ]);
};

export default useLightboxKeyboard;
